import { listObras } from "@/modules/obras/obras.gateway";
import { DEFAULT_OBRAS_SORT, OBRAS_CARDS_PAGE_SIZE } from "@/modules/obras/obras-lista.types";
import type { ObraListaItem, ObrasFilters, ObrasSort } from "@/modules/obras/obras-lista.types";
import { useListingCards } from "@/shared/hooks";
import type { ListingCardsColumnState } from "@/shared/hooks";
import { OBRAS_LISTA_ERROR_MESSAGE, OBRAS_LISTA_FORBIDDEN_MESSAGE } from "./use-obras-lista";

export type ObrasCardsColumnState = ListingCardsColumnState<ObraListaItem>;

const MESSAGES = { forbidden: OBRAS_LISTA_FORBIDDEN_MESSAGE, error: OBRAS_LISTA_ERROR_MESSAGE };

export interface UseObrasCardsParams {
  search: string;
  /** Os filtros de status não entram aqui: cada coluna consulta o seu próprio status. */
  filters: ObrasFilters;
  sort?: ObrasSort;
  /** Códigos dos status que viram colunas, na ordem de exibição (`SEM_STATUS` = obras sem status). */
  columns: string[];
}

/**
 * Visão Cards (RN04): uma consulta por coluna de status, `pageSize` 10; "Mostrar mais
 * obras" pede a próxima página só daquela coluna e anexa sem duplicar. Mudar busca,
 * filtro ou ordenação reinicia todas as colunas do começo.
 */
export function useObrasCards({
  search,
  filters,
  sort = DEFAULT_OBRAS_SORT,
  columns,
}: UseObrasCardsParams) {
  return useListingCards<ObraListaItem, ObrasFilters, ObrasSort["field"]>({
    search,
    filters,
    sort,
    columns,
    pageSize: OBRAS_CARDS_PAGE_SIZE,
    fetchColumnPage: ({ column, busca, filters: criteria, page, pageSize, sort: order, signal }) =>
      listObras({
        busca,
        filters: { ...criteria, statusObra: [column] },
        page,
        pageSize,
        sort: order,
        signal,
      }),
    getItemId: (obra) => obra.id,
    messages: MESSAGES,
  });
}
